import { render, staticRenderFns } from "./fpdpay.vue?vue&type=template&id=07d439cc&scoped=true&"
import script from "./fpdpay.vue?vue&type=script&lang=js&"
export * from "./fpdpay.vue?vue&type=script&lang=js&"
import style0 from "./fpdpay.vue?vue&type=style&index=0&id=07d439cc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d439cc",
  null
  
)

export default component.exports